import React from 'react'
import ResponsiveAppBar from '../Widgets/ResponsiveAppBar'
function Header() {
    return (
        <>
        <ResponsiveAppBar/>
        </>
    )
}

export default Header
